import { useState } from "react";
import { Edit } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SenderMatchConditionEditPanel } from "./SenderMatchConditionEditPanel";

interface SenderMatchConditionSummaryProps {
  value: string[];
  onChange: (value: string[]) => void;
}

export function SenderMatchConditionSummary({ value, onChange }: SenderMatchConditionSummaryProps) {
  const [isEditPanelOpen, setIsEditPanelOpen] = useState(false);

  const getConditionText = () => {
    if (!value || value.length === 0) {
      return "No sender patterns specified";
    }

    const items = value.slice(0, 3).map(item => `'${item}'`).join(' or ');
    const remaining = value.length > 3 ? ` and ${value.length - 3} more` : '';
    
    return `Sender matches one of these addresses ${items}${remaining}`;
  };

  return (
    <>
      <div className="flex items-center justify-between p-3 bg-muted/50 rounded-md">
        <span className="text-sm text-foreground">{getConditionText()}</span>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsEditPanelOpen(true)}
          className="h-6 w-6 p-0"
        >
          <Edit className="h-3 w-3" />
        </Button>
      </div>
      
      <SenderMatchConditionEditPanel
        isOpen={isEditPanelOpen}
        onClose={() => setIsEditPanelOpen(false)}
        value={value}
        onChange={onChange}
      />
    </>
  );
}